import { render, staticRenderFns } from "./form-component-tree-checkbox.vue?vue&type=template&id=14f82d16"
import script from "./form-component-tree-checkbox.vue?vue&type=script&lang=ts"
export * from "./form-component-tree-checkbox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports